import SEO from "./SEO";
import "../index.css";

export default function Hero() {
  return (
    <>
      <SEO
        title="Ferej Hotel | Best Hotel in Harar, Ethiopia"
        description="Welcome to Ferej Hotel Sol — the best hotel in Harar, Ethiopia. Experience comfort, hospitality, and modern rooms. Book your stay today!"
        keywords="hotel in Harar, best hotel in Harar, Ferej Hotel, Ferej Hotel in Harar, Ferej Hotel Sol, Harar Ethiopia hotel"
      />

      <section
        id="hero"
        className="relative h-screen flex items-center justify-center bg-fixed bg-center bg-cover overflow-hidden"
        style={{
          backgroundImage: "url('/best.jpg')",
        }}
      >
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/50 to-black/90"></div>

        {/* Animated Light Orbs */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute w-10 h-10 bg-yellow-200/40 rounded-full blur-2xl top-1/4 left-1/3 animate-pulse"></div>
          <div className="absolute w-16 h-16 bg-yellow-400/30 rounded-full blur-3xl bottom-1/4 right-1/4 animate-ping"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 text-center px-6 sm:px-10 lg:px-16">
          {/* Main Heading */}
          <h1
            className="text-5xl sm:text-7xl font-serif font-extrabold text-transparent bg-clip-text 
                       bg-gradient-to-r from-yellow-200 via-yellow-300 to-yellow-400 drop-shadow-[0_6px_15px_rgba(255,215,0,0.5)]
                       animate-slideInUp"
          >
            <span className="inline-block text-yellow-100 animate-float">
              Welcome to
            </span>{" "}
            <span className="italic text-yellow-300 animate-float-slow">
              Ferej Hotel
            </span>
          </h1>

          {/* Subtitle */}
          <p
            className="mt-6 text-lg sm:text-2xl text-gray-100 max-w-2xl mx-auto leading-relaxed tracking-wide
                       animate-slideInLeft delay-150"
          >
            Where comfort meets class — enjoy unforgettable luxury and warm hospitality
            in every stay.
          </p>

          {/* Button */}
          <a
            href="/#rooms"
            className="mt-10 inline-block bg-gradient-to-r from-yellow-400 to-yellow-200 text-black font-semibold 
                       px-10 py-4 rounded-full shadow-2xl hover:scale-105 hover:shadow-yellow-300/50 
                       hover:from-yellow-300 hover:to-yellow-100 transition-all duration-500
                       animate-slideInRight delay-300"
          >
            Explore Rooms
          </a>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 animate-bounce">
          <div className="w-1 h-10 bg-yellow-300 rounded-full"></div>
        </div>

        {/* Soft Glow Border */}
        <div className="absolute inset-0 border-[0.5px] border-yellow-200/20 rounded-xl shadow-[0_0_80px_rgba(255,215,0,0.15)]"></div>
      </section>
    </>
  );
}
